import { CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";

export const directionsLabel: CSSObject = {
  display: "block",
  fontWeight: "bold",
  marginTop: "10px",
};

export const directionsTextareaCssWrapper: CSSObject = {
  margin: "0 0 10px",
};

export const directionsTextareaCss = (
  isTextOverflowing: boolean = false,
): CSSObject => ({
  width: "100%",
  display: "inline-block",
  padding: "5px",
  resize: "none",
  overflow: "hidden",
  minHeight: "54px",
  ...(isTextOverflowing
    ? typographyStyles.textXSObj
    : typographyStyles.textMObj),
});
